/* src/announcement/Scene.js */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

import AnnouncementCard from './cards/AnnouncementCard';
import AnnouncementList from './cards/AnnouncementList';

const Announcement = ({ classes }) => (
  <Grid container spacing={16}>
    <Grid item xs={12} md={5}>
      <AnnouncementCard />
    </Grid>
    <Grid item xs={12} md={7}>
      <AnnouncementList />
    </Grid>
  </Grid>
);

export default withStyles({})(Announcement);



// WEBPACK FOOTER //
// ./src/modules/announcement/Scene.js